/**
 * @generated SignedSource<<c78f3445568dd8f4a7ff7120bfd89e83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AggregateLevel = "YEAR" | "MONTH" | "DAY" | "%future added value";
export type GLOBAL_FILTER_CONTEXT = "PROJECTS" | "PEOPLE" | "TASKS" | "TIME_REGS" | "INVOICES" | "SKILLS" | "LABELS" | "PLACEHOLDERS" | "RESOURCES" | "%future added value";
export type GLOBAL_FILTER_FIELD = "AUDIT_ACTOR" | "AUDIT_ACTOR_SOURCE" | "AUDIT_APPROVAL_TYPE" | "AUDIT_BATCH_ID" | "AUDIT_EVENT_DATE" | "AUDIT_EVENT_TYPE" | "AUDIT_FIELD_NAME" | "AUDIT_FROM_STATUS" | "AUDIT_IS_MATERIAL" | "AUDIT_TIME_TYPE" | "AUDIT_TO_STATUS" | "AUDIT_WORK_DATE" | "COMPANY_TASK_ID" | "NAME" | "STATUS" | "PROJECT_STATUS" | "PROJECT_GROUP_STATUS" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_GROUP_SPRINT" | "DESCRIPTION" | "REMAINING" | "TIME_REGS" | "FORECAST" | "TASK_APPROVED" | "START_DATE" | "START_DATE_PROJECT" | "END_DATE" | "END_DATE_PROJECT" | "START_DATE_TIME_REG" | "PHASE_TIME_REG" | "END_DATE_TIME_REG" | "PROJECT_TIME_REG" | "ROLE_TIME_REG" | "TEAM_TIME_REG" | "DEPARTMENT_TIME_REG" | "INTERNAL_TIME_REG" | "TIME_OFF_TIME_REG" | "BILLABLE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_TASK_TIME_REG" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "PERSON_TIME_REG" | "CLIENT_TIME_REG" | "SPRINT_TIME_REG" | "LABEL_TIME_REG" | "TASK_TIME_REG" | "CREATED_AT" | "WITH_TIME_REG" | "WITH_TASKS" | "TASK" | "TASK_LEVEL" | "UPDATED_AT" | "SET_DONE_AT" | "ASSIGNED" | "ASSIGNED_SELF" | "OWNER" | "FOLLOWER" | "LABELS" | "PROJECT_LABELS" | "ROLE" | "PROJECT" | "PROJECT_PERSON" | "CLIENT" | "PROJECT_STAGE" | "PROJECT_STAGE_PROFILE" | "BUG" | "BLOCKED" | "BILLABLE" | "HIGH_PRIORITY" | "STARRED" | "RECENT_TIME" | "RECENT_TASK_ACTIVITY" | "RECENT_ACTIVITY" | "PHASE_CATEGORY" | "SPRINT_CATEGORY" | "DEADLINE" | "OWN_START_DATE" | "OWN_DEADLINE" | "TEAM_MEMBER" | "TEAM" | "PERMISSION_LEVEL" | "CLIENT_GUEST_USERS" | "DEPENDENCIES" | "SUB_TASKS" | "TASK_HIERARCHY" | "DEPARTMENT" | "PERSON" | "NO_CONTACT" | "APPROVAL_STATUS" | "INTERNAL_TIME" | "TIME_OFF" | "PROJECT_FOLLOWER" | "PROJECT_OWNER" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "RATE_CARD" | "CONTACT" | "INVOICED" | "SKILL" | "PRIORITY_LEVEL" | "PROJECT_GROUP" | "PROGRAM" | "FILTER_BY_TIME_REG_SETTINGS" | "BILL_TO" | "BILL_FROM" | "PROJECT_MANUAL_PROGRESS" | "RETAINER_PERIOD" | "PROJECT_WIN_CHANCE" | "CLIENT_CONTACT_CLIENT_ID" | "CLIENT_CONTACT_COMPANY_ID" | "CLIENT_CONTACT_ID" | "CLIENT_CONTACT" | "CLIENT_CONTACT_NAME" | "CLIENT_CONTACT_FIRST_NAME" | "CLIENT_CONTACT_LAST_NAME" | "CLIENT_CONTACT_EMAIL" | "CLIENT_CONTACT_STATUS" | "CLIENT_CONTACT_IS_GUEST_USER" | "PHASE" | "SPRINT" | "DELIVERABLE" | "PARENT" | "PROGRESS" | "ESTIMATE" | "CREATED" | "UPDATED" | "PROJECT_STATUS_RAG" | "PROGRESS_BUCKET" | "WIN_CHANCE_BAND" | "TOTAL_REGISTERED_HOURS" | "BILLABLE_HOURS" | "NON_BILLABLE_HOURS" | "RETAINER_OVER_UNDER" | "RETAINER_PERIOD_START" | "RETAINER_PERIOD_END" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "IS" | "IS_NOT" | "IS_ALL" | "IS_NOT_ALL" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "LESS" | "LESS_OR_EQUAL" | "IN" | "NOT_IN" | "ALL_IN" | "NOT_ALL_IN" | "%future added value";
export type TaskSearchQueryType = {
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
};
export type GlobalSearchFilterType = {
  field?: GLOBAL_FILTER_FIELD | null;
  operator?: GLOBAL_FILTER_OPERATOR | null;
  value?: ReadonlyArray<string | null> | null;
  context?: GLOBAL_FILTER_CONTEXT | null;
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
  logicalOperator?: GLOBAL_FILTER_LOGICAL_OPERATOR | null;
};
export type RevenueCostProfitCharts_Query$variables = {
  projectId?: string | null;
  startYear: number;
  startMonth: number;
  startDay: number;
  endYear: number;
  endMonth: number;
  endDay: number;
  searchQuery?: TaskSearchQueryType | null;
  aggregateLevel: AggregateLevel;
};
export type RevenueCostProfitCharts_Query$data = {
  readonly viewer: {
    readonly id: string;
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"RevenueCostProfitCharts_viewer">;
  } | null;
};
export type RevenueCostProfitCharts_Query = {
  variables: RevenueCostProfitCharts_Query$variables;
  response: RevenueCostProfitCharts_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aggregateLevel"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDay"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endMonth"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endYear"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDay"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startMonth"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startYear"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "project_budget_v3_revenue_cost_profit_charts"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"project_budget_v3_revenue_cost_profit_charts\")"
},
v12 = {
  "kind": "Variable",
  "name": "aggregateLevel",
  "variableName": "aggregateLevel"
},
v13 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v14 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v15 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v16 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v17 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v18 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v19 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RevenueCostProfitCharts_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "args": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              },
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "RevenueCostProfitCharts_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RevenueCostProfitCharts_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tier",
                "storageKey": null
              },
              (v20/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "internalId",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "estimationUnit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budget",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodBudgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "addAccumulatedNumbers",
                    "value": true
                  },
                  (v12/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "aggregates",
                    "value": [
                      "billableActualTimeAndExpenses",
                      "billablePlannedTimeAndExpenses",
                      "billableTotalTimeAndExpensesAtCompletion",
                      "baselineTimeAndExpenses",
                      "actualCost",
                      "plannedCost",
                      "totalCostAtCompletion",
                      "baselineCost",
                      "actualProfit",
                      "plannedProfit",
                      "totalRevenueProfitAtCompletion",
                      "baselineProfit",
                      "totalRevenueRecognition",
                      "recognitionProfit"
                    ]
                  },
                  {
                    "kind": "Literal",
                    "name": "convertToProjectCurrency",
                    "value": true
                  },
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "aggregatedFinancialNumbers",
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dd260d8f6c97f15ad1a1c2f52f3ad65c",
    "id": null,
    "metadata": {},
    "name": "RevenueCostProfitCharts_Query",
    "operationKind": "query",
    "text": "query RevenueCostProfitCharts_Query(\n  $projectId: ID\n  $startYear: Int!\n  $startMonth: Int!\n  $startDay: Int!\n  $endYear: Int!\n  $endMonth: Int!\n  $endDay: Int!\n  $searchQuery: TaskSearchQueryType\n  $aggregateLevel: AggregateLevel!\n) {\n  viewer {\n    id\n    actualPersonId\n    component(name: \"project_budget_v3_revenue_cost_profit_charts\")\n    ...RevenueCostProfitCharts_viewer_vD8ov\n  }\n}\n\nfragment RevenueCostProfitCharts_viewer_vD8ov on Viewer {\n  company {\n    tier\n    currency\n    id\n  }\n  project(internalId: $projectId) {\n    projectFirstDateYear\n    projectFirstDateMonth\n    projectFirstDateDay\n    projectLastDateYear\n    projectLastDateMonth\n    projectLastDateDay\n    rateCard {\n      currency\n      id\n    }\n    estimationUnit\n    budget\n    budgetType\n    billable\n    defaultPeriodBudgetType\n    aggregatedFinancialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregates: [billableActualTimeAndExpenses, billablePlannedTimeAndExpenses, billableTotalTimeAndExpensesAtCompletion, baselineTimeAndExpenses, actualCost, plannedCost, totalCostAtCompletion, baselineCost, actualProfit, plannedProfit, totalRevenueProfitAtCompletion, baselineProfit, totalRevenueRecognition, recognitionProfit], aggregateLevel: $aggregateLevel, addAccumulatedNumbers: true, searchQuery: $searchQuery, convertToProjectCurrency: true)\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "70d08d435c954fa03e6bb4adf32fd29c";

export default node;
